import { TIMER_STATUS, TIMER_TYPE } from "../types/CommonTypes";

const getBaseLabel = (timerType?: TIMER_TYPE) => {
  switch (timerType) {
    case TIMER_TYPE.ALARM:
      return "Alarm";
    case TIMER_TYPE.STOPWATCH:
      return "Stopwatch";
    case TIMER_TYPE.TIMER:
    default:
      return "Timer";
  }
};

export default function getTimerTitle(
  status: TIMER_STATUS,
  action: string,
  timerType?: TIMER_TYPE,
) {
  const label = getBaseLabel(timerType);
  switch (status) {
    case TIMER_STATUS.PAUSED:
      return `${label} Paused`;
    case TIMER_STATUS.RUNNING:
      return action === "CREATE" ? `${label} Set` : `${label} Resumed`;
    case TIMER_STATUS.STOPPED:
      return `${label} Ended`;
  }
}
